var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipsis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33366 7.99967C7.33366 8.36786 7.63214 8.66634 8.00033 8.66634C8.36852 8.66634 8.66699 8.36786 8.66699 7.99967C8.66699 7.63148 8.36852 7.33301 8.00033 7.33301C7.63214 7.33301 7.33366 7.63148 7.33366 7.99967Z",
    stroke: "#282D38",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33366 12.6667C7.33366 13.0349 7.63214 13.3333 8.00033 13.3333C8.36852 13.3333 8.66699 13.0349 8.66699 12.6667C8.66699 12.2985 8.36852 12 8.00033 12C7.63214 12 7.33366 12.2985 7.33366 12.6667Z",
    stroke: "#282D38",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33366 3.33366C7.33366 3.70185 7.63214 4.00033 8.00033 4.00033C8.36852 4.00033 8.66699 3.70185 8.66699 3.33366C8.66699 2.96547 8.36852 2.66699 8.00033 2.66699C7.63214 2.66699 7.33366 2.96547 7.33366 3.33366Z",
    stroke: "#282D38",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsis);
export default __webpack_public_path__ + "static/media/ellipsis.9b11fc6c8128f30d0519fd3b8b9a59b4.svg";
export { ForwardRef as ReactComponent };